<template>
    <v-system-bar>    
        <v-layout rop wrap>
            <v-flex xs1 offset-xs5 hidden-sm-and-down>
                <v-flex v-if="$store.state.docNameVisible">
                    {{getDocTitle()}}
                </v-flex>                
            </v-flex>            
            <v-flex xs6 hidden-sm-and-down v-if="($store.state.usuario.type == 'Comercial') && ($store.state.customer)" >
                <a @click="$store.commit('setDialogComercial',true);">
                {{$store.state.customer.no}} - 
                {{$store.state.customer.name}}
                </a>
                <span v-if="$store.state.idEvento != ''">📝</span>
                <span>{{$store.state.idEvento}}</span>
            </v-flex>
            <v-flex xs6 v-else hidden-sm-and-down>                
                {{$store.state.usuario.custNo}} - 
                {{$store.state.usuario.custName}}                
            </v-flex>        
            <v-flex xs12 hidden-md-and-up v-if="($store.state.usuario.type == 'Comercial') && ($store.state.customer)" >
                <a @click="$store.commit('setDialogComercial',true);">
                {{$store.state.customer.no}} - 
                {{$store.state.customer.name}}
                </a>
                <span v-if="$store.state.idEvento != ''">📝</span>
            </v-flex>
            <v-flex xs12 v-else hidden-md-and-up>                
                {{$store.state.usuario.custNo}} - 
                {{$store.state.usuario.custName}}                
            </v-flex>            
        </v-layout>        
    </v-system-bar>
</template>
<script>
export default {
    name: 'SystemBar',    
}
</script>
<style scoped>
.docTitle{
    color: black;
}
</style>